
<template>
    <vxe-modal v-model="dialoglocaluploadFile" title="添加本地资料" width="500px" height="300px" show-zoom resize transfer
        draggable>
        <!-- <ZyJsonForms  ref="myzyJsonforms"></ZyJsonForms> -->
        <zyUpload :path="`md/cmdp专业版用户上传本地资料/${title}`" ref="myzyUpload" @finishUpload="finishUpload"></zyUpload>

        <div class="tips">
            选择标签，可以提供更好、更准确的服务
        </div>
        <div>
            <v-radio-group v-model="fileTags" row>
                <v-radio v-for="item in opfileTags" :label="item.label" :value="item.value"></v-radio>
            </v-radio-group>
        </div>

        <v-btn style="color:white;" block color="#66b1ff" @click="confirmUpload">上传</v-btn>
    </vxe-modal>
</template>

<script>
import zyUpload from "@/components/common/zyUpload.vue"
export default {
    name: 'localuploadFile',
    components:{zyUpload},
    data() {
        return {
            dialoglocaluploadFile: false,
            uploadInfo: false,
            opfileTags: [
                { label: "财务报表", value: "财务报表" },
                { label: "审计报表", value: "审计报表" },
            ],
            fileTags: "",
            uploadInfo: false,
            title:""
        }
    },
    methods: {
        init(title) {
            this.uploadInfo = false;
            this.fileTags = "";
            this.dialoglocaluploadFile = true;
            let that=this;
            this.title=title;
            this.$nextTick(() => {
                that.$refs.myzyUpload.init()             
            })
        },
        finishUpload(params) {
            this.uploadInfo = params;
            console.log(params);
        },
        confirmUpload() {
            this.$EventBus.$emit("updatelocalInfo",{fileList:this.uploadInfo,type:'files'})
            this.dialoglocaluploadFile = false;
        }

    },

}
</script>
